// src/app/layout/footer/footer.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_VERSION } from '../../../environments/version';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="layout-footer">
      <span class="footer-text">
        © {{ currentYear }} SoftRent - Sistema de Gestión de Arriendos
      </span>
      <span class="footer-links">
        <a href="https://wa.me/56974131158?text=Hola%2C%20necesito%20soporte%20con%20SoftRent" target="_blank">Soporte</a>
        <span class="separator">|</span>
        <span>Versión {{ version }}</span>
      </span>
    </div>
  `,
  styles: [`
    .layout-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.75rem 2rem;
      font-size: var(--fs-xs);
      color: var(--ink-mute);
      border-top: 1px solid var(--hairline);
    }

    .footer-links {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      a {
        color: var(--ink-mute);
        text-decoration: none;
        transition: color 150ms ease;

        &:hover {
          color: var(--accent-text);
        }
      }

      .separator {
        color: var(--hairline);
      }
    }

    @media (max-width: 768px) {
      .layout-footer {
        flex-direction: column;
        gap: 0.5rem;
        text-align: center;
        padding: 1rem;
      }
    }
  `]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  version = APP_VERSION;
}